import * as education from './education'
import * as content from './content'
import * as user from './user'
import * as question from './question'

export default {
  ...education,
  ...content,
  ...user,
  ...question
}
